import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check--sharp",
  "use": "icon-check--sharp-usage",
  "viewBox": "0 0 15 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 12\" id=\"icon-check--sharp\"><path d=\"m14.719 2.129-8.981 9.136-5.56-5.656 1.74-1.77 3.82 3.886L12.978.36l1.74 1.77Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol